import React from 'react';
import { FormattedMessage } from 'react-intl';

import { transactionTypeMessages } from '../messages';

/**
 * @param {object} props
 * @param {import('../transaction-history').TextCell} props.cell
 * @returns {JSX.Element}
 */
export const TransactionTypeCell = ({ cell }) => {
  const message = transactionTypeMessages[cell.value];
  return message ? <FormattedMessage {...message} /> : null;
};
